module.exports = __webpack_public_path__ + "images/citiheader11149d2e78e8151d76210c682a2e75c6.png";